import { atom } from 'recoil';
import { PartySubTypeEnum, PartyTypeEnum, } from '@zurich/api/party';
export const partyAtom = atom({
    key: 'party',
    default: {
        partyType: PartyTypeEnum.N,
        partySubType: PartySubTypeEnum.PRIVATPERSON,
        lastName: '',
    },
});
export const partyDataStateAtom = atom({
    key: 'partyDataState',
    default: 'unset',
});
export const bankAccountsAtom = atom({
    key: 'bankAccounts',
    default: {
        bankAccounts: [],
    },
});
export const communicationChannelsAtom = atom({
    key: 'communicationChannels',
    default: {
        channels: [],
    },
});
export const relationsAtom = atom({
    key: 'relations',
    default: [],
});
export const relationsDataStateAtom = atom({
    key: 'relationsDataState',
    default: 'unset',
});
export const householdAtom = atom({
    key: 'household',
    default: {},
});
export const householdDataStateAtom = atom({
    key: 'householdDataState',
    default: 'unset',
});
export const putPartyAtom = atom({
    key: 'putParty',
    default: false,
});
export const partyDocumentAtom = atom({
    key: 'document',
    default: [],
});
export const partyPepSanctionStatusAtom = atom({
    key: 'partyPepSanctionStatus',
    default: {},
});
